import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from "reselect";

import runAnalysis from '../actions/query-api/run-analysis';

import './style.css'

const PortfoliosMatchModal = props => {

  const rerun = value => {
    props.setAwaitingNewData(true);
    props.setInvestmentGoal(value);
    props.runAnalysis(true);
    props.ok();
  }

  let current = props.investmentGoalOptions
    .find(d => d.value === props.investmentGoal)
  let alternatives = props.investmentGoalOptions
    .filter(d => d.value !== props.investmentGoal && d.value !== 'C')
    .slice(0,2)
  return (<div className="portfolios-match-modal">
    <div>{props.TEXT.dpdDidNotReplaceModal}</div>
    <div className="bold">{current.label}</div>
    <div className="link"
      onClick={() => props.ok()}>{props.TEXT.showMeResultsAnywayModal}</div>
    <br/>
    <div>{props.TEXT.showMeSolutionForModal}</div>
    <div>
      <span className="secondary-link"
        onClick={() => rerun(alternatives[0].value)}>
        {alternatives[0].label}
      </span>
      <span className="secondary-link"
        onClick={() => rerun(alternatives[1].value)}>
        {alternatives[1].label}
      </span>
    </div>
    <br/>
    <div className="link"
      onClick={() => props.clearAnalysis()}>{props.TEXT.orCompareManuallyModal}</div>
  </div>)
}

const mapStateToProps = createStructuredSelector({
  investmentGoal: state => state.entry.original.investmentGoal,
  investmentGoalOptions: state => state.investmentGoalOptions,
  TEXT: state => state.complianceText,
});

const mapDispatchToProps = dispatch => ({
  ok: () => dispatch({ type: 'CLOSE_DIALOG' }),
  setInvestmentGoal: value => dispatch({ type: 'SET_INVESTMENT_GOAL', value }),
  runAnalysis: () => dispatch(runAnalysis()),
  setAwaitingNewData: value => dispatch({ type: "SET_AWAIT_STATUS", status: value }),
  clearAnalysis: () => {
    dispatch({ type: 'CLEAR_ANALYSIS' })
    dispatch({ type: 'CLOSE_DIALOG' })
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PortfoliosMatchModal);


// WEBPACK FOOTER //
// ./src/Report/PortfoliosMatchModal.js